export default function errorToObj(error) {
    const errorObj = {};

    Object.getOwnPropertyNames(error)
        .sort()
        .forEach((key) => {
            errorObj[key] = error[key];
        });

    return errorObj;
}
